<nz-card id="vertical-profile-element-container" class="condensed-card" style="height: 100%">
    <div class="card-header">
        <h2 style="font-weight: bold; font-size: 15px;">
            Vertical Profile

            @if(selectedLog(); as data){
            [{{data.name}}]
            }
        </h2>
        <div style="display: flex; align-items: center; gap: 10px;" class="omit-from-screenshot">
            <a (click)="resetZoom()" nz-tooltip nzTooltipTitle="Reset Zoom" style="font-size: 20px;">
                <nz-icon nzType="sync" nzTheme="outline" />
            </a>
            <button nz-button nzType="default" nzSize="small" class="settings-btn"
                nz-dropdown [nzDropdownMenu]="verticalProfileMenu" [nzClickHide]="false" nzTrigger="click">
                <nz-icon nzType="setting" nzTheme="outline" />
                <nz-icon class="settings-caret" nzType="down" nzTheme="outline" />
            </button>
        </div>
    </div>
    <div #chartContainer class="canvas-container" style="width: 100%; position: relative;"></div>
    <div class="metrics-displayer omit-from-screenshot">
        <table class="styled-table">
            <tr>
                <td>Depth (m)</td>
                <td>:</td>
                <td>{{depth | number: '1.2-2'}}</td>
            </tr>
            <tr>
                <td>Value (m/s)</td>
                <td>:</td>
                <td>{{profileValue | number: '1.2-2'}}</td>
            </tr>
        </table>
    </div>
</nz-card>




<nz-dropdown-menu #verticalProfileMenu="nzDropdownMenu">
    <ul nz-menu [nzSelectable]="false">
        <li nz-menu-item class="custom-menu-item">
            <div style="display: flex">
                <nz-form-item class="floating-label" style="margin: 0">
                    <nz-form-label for="min" [nzNoColon]="true">XMin</nz-form-label>
                    <nz-input-number style="width: 100%;" [ngModel]="verticalProfileService.xMin()"
                        (change)="setValueOfSignal($event, verticalProfileService.xMin)" />
                </nz-form-item>
                <nz-form-item class="floating-label" style="margin: 0">
                    <nz-form-label for="max" [nzNoColon]="true">XMax</nz-form-label>
                    <nz-input-number style="width: 100%;" [ngModel]="verticalProfileService.xMax()"
                        (change)="setValueOfSignal($event, verticalProfileService.xMax)" />
                </nz-form-item>
            </div>
        </li>

        <li nz-menu-divider></li>

        <li nz-menu-item class="custom-menu-item">
            <div style="display: flex;">
                <nz-form-item class="floating-label" style="margin: 0px;">
                    <nz-form-label [nzNoColon]="true">Depth Min</nz-form-label>
                    <nz-input-number style="width: 100%;"
                        (change)="setValueOfSignal($event, jobStateService.rangesStart.depth, 0)" [nzMin]="0"
                        [nzMax]="jobStateService.rangesEnd.depth() - 100"
                        [ngModel]="jobStateService.rangesStart.depth()" />
                </nz-form-item>
                <nz-form-item class="floating-label" style="margin: 0px;">
                    <nz-form-label [nzNoColon]="true">Depth Max</nz-form-label>
                    <nz-input-number style="width: 100%;"
                        (change)="setValueOfSignal($event, jobStateService.rangesEnd.depth, depthMax())"
                        [nzMin]="jobStateService.rangesStart.depth() + 100" [nzMax]="depthMax()"
                        [ngModel]="jobStateService.rangesEnd.depth()" />
                </nz-form-item>
            </div>
        </li>

        <li nz-menu-divider></li>

        @if(selectedLog()) {
        <li nz-menu-divider></li>
        <li nz-menu-item class="custom-menu-item">
            <label style="flex: 1" nz-checkbox [(ngModel)]="showVelocityProfile">Velocity Profile</label>
        </li>
        <li nz-menu-item class="custom-menu-item">
            <label style="flex: 1" nz-checkbox [(ngModel)]="showSonicLog">Sonic Log</label>
        </li>
        <li nz-menu-item class="custom-menu-item">
            <label style="flex: 1" nz-checkbox [(ngModel)]="viewerSettingsService.showSonicSamples">Show Sample Points</label>
        </li>
        }
        <li nz-menu-divider></li>
        <li nz-menu-item (click)="downloadVerticalProfile()">Download</li>
    </ul>
</nz-dropdown-menu>